export default __webpack_public_path__ + "static/media/genes@2x.643593d1.png";